import { isVisualRefreshEnabled } from '../../core/utils/is-visual-refresh-enabled.js';
import {
  DATA_TABLE_BORDER_WIDTH,
  DATA_TABLE_BORDER_WIDTH_VISUAL_REFRESH,
} from '../DataTable/constants.js';

/**
 * Returns the current DataTable border width in pixels based on whether visual refresh is enabled.
 * @returns 1 when visual refresh is active, 2 otherwise.
 * @internal
 */
export function getDataTableBorderWidth(): number {
  return isVisualRefreshEnabled()
    ? DATA_TABLE_BORDER_WIDTH_VISUAL_REFRESH
    : DATA_TABLE_BORDER_WIDTH;
}
